<tag-input [(ngModel)]='value' [separatorKeys]="separatorKeys" [addOnBlur]="true" [errorMessages]="errorMessages"
  (onTextChange)="onChange($event)" [pasteSplitPattern]="pasteSplitPattern" addOnPaste="true"
  (onAdd)="onItemAdded($event)" [validators]="formControl.validator" [identifyBy]="valueField" [displayBy]="textField"
  [maxItems]="maxItems" [placeholder]="placeholder" [secondaryPlaceholder]="secondaryPlaceholder"></tag-input>
